export default "__VITE_ASSET__Bvt_dnf2__"